/* global femcare */

femcare.product.cart = {
    init: function () {
        this.$cartModal = $('#cartModal');
        this.$menuModal = $('#menuModal');
        this.$stashModal = $('#stashModal');

        if (this.$cartModal.length) {
            this.$cartNotification = $('.cart-notification');
            this.$items = this.$cartModal.find('.cart__items');
            this.antiforgeryToken = this.$cartModal.attr('data-token');
            this.refreshCartCount();
            this.initHandlers();
        }
    },

    initHandlers: function () {
        this.initOpenCartHandlers();
        this.initCloseHandlers();
        this.initCartItemCountHandlers();
        this.initCartNotificationHandlers();

        $('.navigation-bar__icon--cart').on('click', this.openCart.bind(this));
        $('.navigation-bar__cart-counter').on('click', this.openCart.bind(this));
        $('.navigation-bar__icon--mobile-cart').on('click', '.icon-shopping-bag', this.openCart.bind(this));
        $('.cart__close').on('click', this.closeCart.bind(this));
        $('.navigation-bar__icon--mobile-cart').on('click', '.icon-close', this.closeCart.bind(this));

        $(window).on('resize', $.proxy(this.onResizeHideCartModal, this));

        femcare.shared.pubsub.subscribe('CART_ITEM_COUNT_UPDATED', function (count) {
            this.updateCartCounter(count);
        }.bind(this));
    },

    initCartItemCountHandlers: function () {
        this.$cartModal.on('countChanged', '.counter', function (e, count) {
            var $counter = $(e.currentTarget);
            var skuId = $counter.closest('.cart-item').attr('data-sku-id');
            var skuEanId = $counter.closest('.cart-item').attr('data-ean-id');

            this.updateCartItemCount(skuId, skuEanId, count);
        }.bind(this));

        this.$cartModal.on('click', '.cart-item__delete', function (e) {
            var $deleteBtn = $(e.currentTarget);
            var $cartItem = $deleteBtn.closest('.cart-item');

            var skuId = $cartItem.attr('data-sku-id');
            var skuEanId = $cartItem.attr('data-ean-id');
            var currentQuantity = $cartItem.find('.counter').counter('getCount');

            var productName = $cartItem.find('.cart-item__name').text();
            var productId = $cartItem.attr('data-product-id');
            var sellingPrice = $cartItem.attr('data-selling-price');
            var category = $cartItem.attr('data-category');
            var currency = $cartItem.attr('data-currency');

            this.updateCartItemCount(skuId, skuEanId, 0, function () {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push(
                    {
                        event: 'removeFromCart',
                        currencyCode: currency,
                        ecommerce: {
                            remove: {
                                products:
                                    [{
                                        name: productName,
                                        id: productId,
                                        price: sellingPrice,
                                        quantity: currentQuantity,
                                        category: category
                                    }]
                            }
                        }
                    }
                );
            });
        }.bind(this));
    },

    updateCartItemCount: function (skuId, skuEan, count, onSuccessEndCallback) {

        var data = {
            ean: skuEan,
            id: skuId,
            quantity: count
        };

        femcare.shared.ui.setLoadingOverlay(true);

        $.ajax({
            url: femcare.shared.util.baseUrl + 'ajax/products/product/updateBagItem',
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(data),
            headers: { 'RequestVerificationToken': this.antiforgeryToken },
            success: function (res) {
                var cartItemCount = (res.order && res.order.totalItems) || 0;
                femcare.shared.pubsub.publish('CART_ITEM_COUNT_UPDATED', cartItemCount);
                this.renderCart(res);

                onSuccessEndCallback && onSuccessEndCallback();
            }.bind(this),
            complete: function () {
                femcare.shared.ui.setLoadingOverlay(false);
            }
        });

        // $.ajax({
        //     url: '/json/ajax-cart-increment.json',
        //     method: 'GET',
        //     dataType: 'json',
        //     success: function (data) {
        //         this.renderCart(data);

        //     }.bind(this)
        // });

    },

    initOpenCartHandlers: function () {
        this.$cartModal.on('show.bs.modal', function () {
            if (this.$menuModal.is(':visible')) {
                this.$menuModal.modal('hide');
            }
            if (this.$stashModal.is(':visible')) {
                this.$stashModal.modal('hide');
            }
        }.bind(this));

        this.$cartModal.on('shown.bs.modal', function () {
            if (!femcare.shared.util.isRichNavbarActive()) {
                $('body').css('position', 'fixed');
                $('.navigation-bar').addClass('navigation-bar--overlayed');
                $('.navigation').addClass('navigation--overlayed');
                $('.navigation-bar__icon--mobile-cart i')
                    .removeClass('icon-shopping-bag')
                    .addClass('icon-close');
                $('.navigation-bar__icon--mobile-cart .navigation-bar__cart-counter').hide();
            }
        });
    },

    initCloseHandlers: function () {
        this.$cartModal.on('hide.bs.modal', function () {
            $('body').css('position', 'static');
            $('.navigation-bar').removeClass('navigation-bar--overlayed');
            $('.navigation').removeClass('navigation--overlayed');
            $('.navigation-bar__icon--mobile-cart i')
                .removeClass('icon-close')
                .addClass('icon-shopping-bag');
            $('.navigation-bar__icon--mobile-cart .navigation-bar__cart-counter').show();
        });
    },

    initCartNotificationHandlers: function () {
        this.$cartNotification.find('.cart-notification__close').on('click', function () {
            this.$cartNotification.hide();
        }.bind(this));

        this.$cartNotification.find('.cart-notification-view__button').on('click', function () {
            this.openCart();
        }.bind(this));
    },

    openCart: function (e) {
        e && e.preventDefault();
        femcare.shared.ui.setLoadingOverlay(true);

        return $.ajax({
            url: femcare.shared.util.baseUrl + 'ajax/products/product/getbag',
            dataType: 'json',
            method: 'GET',
            headers: { 'RequestVerificationToken': this.antiforgeryToken },
            success: function (res) {
                this.renderCart(res);
                this.$cartModal.modal('show');
                this.$cartNotification.hide();
            }.bind(this),
            complete: function () {
                femcare.shared.ui.setLoadingOverlay(false);
            }
        });

        // $.ajax({
        //     url: '/json/ajax-cart-order.json',
        //     dataType: 'json',
        //     method: 'GET',
        //     success: function (data) {
        //         this.renderCart(data);
        //         this.$cartModal.modal('show');
        //         this.$cartNotification.hide();
        //     }.bind(this)
        // });
    },

    displayAddedNotification: function (product, checkoutUrl) {
        this.$cartNotification.find('.cart-notification__name').text(product.name);
        this.$cartNotification.find('.cart-notification__skuName').text(product.productSkuName);
        this.$cartNotification.find('.cart-notification__image').attr('src', product.image.url);
        this.$cartNotification.find('.cart-notification__count').text(product.quantity.initial);
        this.$cartNotification.find('.cart-notification__price').text(product.priceInformation.sellingPrice);
        this.$cartNotification.find('.cart-notification-checkout__button').attr('href', checkoutUrl);
        this.$cartNotification.show();
    },

    refreshCartCount: function () {
        $.ajax({
            url: femcare.shared.util.baseUrl + 'ajax/products/product/getbag?onlyTotal',
            dataType: 'json',
            method: 'GET',
            headers: { 'RequestVerificationToken': this.antiforgeryToken },
            success: function (res) {
                var cartItemCount = (res && res.totalItems) || 0;
                femcare.shared.pubsub.publish('CART_ITEM_COUNT_UPDATED', cartItemCount);
            }
        });
    },

    closeCart: function (e) {
        e.preventDefault();
        this.$cartModal.modal('hide');
    },

    renderCart: function (data) {
        var hasItems = data.success && data.order;

        this.$cartModal
            .find('.cart__body')
            .toggleClass('cart__body--empty', !hasItems);

        if (hasItems) {
            var order = data.order;
            var $itemList = this.$cartModal.find('.cart__items');

            $itemList.empty();

            order.items.forEach(function (item) {
                var $item = $('<li class="cart-item"></li>');
                $item.attr('data-sku-id', item.productSkuId);
                $item.attr('data-ean-id', item.productSkuEan);
                $item.attr('data-product-id', item.productId);
                $item.attr('data-selling-price', item.priceInformation.sellingPriceNoFormat);
                $item.attr('data-currency', item.priceInformation.currency.code);
                $item.attr('data-category', item.category);
                var $media = $('<div class="cart-item__media"></div>');
                var $image = $('<img class="cart-item__image"/>');
                $image.attr('src', item.image.url);
                $media.append($image);

                var $info = $('<div class="cart-item__info"></div>');
                var $name = $('<div class="cart-item__name"></div>');
                var $category = $('<div class="cart-item__name"></div>').text(item.name);
                var $skuName = $('<div class="cart-item__skuName"></div>').text(item.productSkuName);
                $name.append($category);
                $name.append($skuName);

                var $stock = $('<div class="cart-item__stock"></div>');

                var isInStock = item.quantity.max > 0 && item.quantity.available;

                var $message = $('<div class="cart-item__availability"></div>');
                $message.addClass('cart-item__availability--' + (isInStock ? 'in-stock' : 'out-of-stock'));
                $message.text(item.quantity.availability.stockMessage);
                $stock.append($message);

                if (isInStock) {
                    var $counterWrapper = $('<div class="cart-item__counter"></div>');
                    var $counter = $('<div class="counter" data-inputId="cartItemQuantity"></div>');
                    $counterWrapper.append($counter);
                    $stock.append($counterWrapper);
                    var $total = $('<div class="cart-item__total">' + item.priceInformation.total + '</div>');
                    $stock.append($total);
                }

                $info.append($name);
                $info.append($stock);

                $stock.find('.counter').counter({
                    count: item.quantity.initial,
                    max: item.quantity.max
                });

                var $delete = $('<div class="cart-item__delete"><i class="icon-trash-can"></i></div>');
                $info.append($delete);

                $item.append($media);
                $item.append($info);

                $itemList.append($item);
            });

            var discount = null;
            var subtotal = null;

            order.totalizers.forEach(function (totalizer) {
                if (totalizer.id === 'Items') {
                    subtotal = totalizer.value;
                } else if (totalizer.id === 'Discounts') {
                    discount = totalizer.value;
                }
            });

            var $discount = this.$cartModal.find('.cart-discount');
            var $discountCost = $discount.find('.cart-discount__cost');

            if (discount) {
                $discountCost.text(discount);
                $discount.show();
            } else {
                $discountCost.text('');
                $discount.hide();
            }

            this.$cartModal.find('.cart-subtotal__cost').text(subtotal);
            this.$cartModal.find('.cart-checkout__button').attr('href', data.order.checkoutUrl);
        }
    },

    updateCartCounter: function (count) {
        $('.navigation-bar__cart-counter').text(count || 0);
        this.$cartModal.find('.cart-indicator__counter').text(count || 0);
    },

    onResizeHideCartModal: function () {
        if (
            this.$cartModal.is(':visible') &&
            femcare.shared.util.isRichNavbarActive()
        ) {
            this.$cartModal.modal('hide');
        }
    }
};